module.exports = __webpack_public_path__ + "img/dots_bg1.d62dffe1.svg";